import React, { useState } from "react";
import { motion } from "framer-motion";
import "./ErrorHandlingDemo.css";

// Custom Error class to simulate Python's MyCustomError
class MyCustomError extends Error {
  constructor(message) {
    super(message);
    this.name = "MyCustomError";
  }
}

const ErrorHandlingDemo = () => {
  const [tab, setTab] = useState("value");
  const [valueInput, setValueInput] = useState("");
  const [typeAInput, setTypeAInput] = useState("");
  const [typeBInput, setTypeBInput] = useState("");
  const [customNum, setCustomNum] = useState(1);
  const [message, setMessage] = useState("");

  const handleDemo = () => {
    try {
      switch (tab) {
        case "value": {
          // simulate Python int conversion
          const n = parseInt(valueInput, 10);
          if (isNaN(n) || valueInput.trim() === "") {
            throw new Error(`ValueError: invalid literal for int() with base 10: '${valueInput}'`);
          }
          setMessage(`Преобразовано число: ${n}`);
          break;
        }
        case "type": {
          // simulate Python + operator type handling
          const aRaw = typeAInput;
          const bRaw = typeBInput;
          const isANum = /^-?\d+$/.test(aRaw);
          const isBNum = /^-?\d+$/.test(bRaw);
          if (isANum && isBNum) {
            const sum = parseInt(aRaw, 10) + parseInt(bRaw, 10);
            setMessage(`Результат сложения: ${sum}`);
          } else if (isANum !== isBNum) {
            throw new Error("TypeError: unsupported operand type(s) for +: 'str' and 'int'");
          } else {
            setMessage(`Конкатенация строк: "${aRaw + bRaw}"`);
          }
          break;
        }
        case "name": {
          // simulate NameError
          throw new Error("NameError: name 'undefined_variable' is not defined");
        }
        case "custom": {
          // simulate custom exception
          if (customNum < 0) throw new MyCustomError("Значение не может быть отрицательным!");
          setMessage(`Число ${customNum} неотрицательное, ошибок нет.`);
          break;
        }
        default:
          break;
      }
    } catch (e) {
      setMessage(e.message);
    }
  };

  return (
    <div className="error-handling-demo">
      <h3>Интерактивная обработка ошибок</h3>
      <div className="tabs">
        {["value","type","name","custom"].map(key => (
          <button
            key={key}
            className={tab === key ? "active" : ""}
            onClick={() => { setTab(key); setMessage(""); }}
          >
            {key === "value" ? "ValueError"
              : key === "type" ? "TypeError"
              : key === "name" ? "NameError"
              : "MyCustomError"}
          </button>
        ))}
      </div>

      <div className="controls">
        {tab === "value" && (
          <div>
            <label>Введите текст для int(): </label>
            <input
              type="text"
              value={valueInput}
              onChange={e => setValueInput(e.target.value)}
              placeholder="например '123' или 'abc'"
            />
          </div>
        )}

        {tab === "type" && (
          <div className="input-pair">
            <div>
              <label>Operand A:</label>
              <input
                type="text"
                value={typeAInput}
                onChange={e => setTypeAInput(e.target.value)}
                placeholder="например '5' или 'hello'"
              />
            </div>
            <div>
              <label>Operand B:</label>
              <input
                type="text"
                value={typeBInput}
                onChange={e => setTypeBInput(e.target.value)}
                placeholder="например '3' или 'world'"
              />
            </div>
          </div>
        )}

        {tab === "name" && (
          <p>Нажмите кнопку, чтобы сымитировать NameError.</p>
        )}

        {tab === "custom" && (
          <div>
            <label>Введите число: </label>
            <input
              type="number"
              value={customNum}
              onChange={e => setCustomNum(e.target.valueAsNumber)}
            />
          </div>
        )}

        <button onClick={handleDemo}>Запустить пример</button>
      </div>

      <motion.div
        className="output"
        initial={{ opacity: 0 }}
        animate={{ opacity: message ? 1 : 0 }}
      >
        {message}
      </motion.div>
    </div>
  );
};

export default ErrorHandlingDemo;